const getDashboardDateTime = (date?: Date | string): number | null => {
  if (!date) return null;

  if (date instanceof Date) {
    const timestamp = date.getTime();
    return Number.isNaN(timestamp) ? null : timestamp;
  }

  const parsedDate = date.match(
    /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2}):(\d{2})/
  );

  if (!parsedDate) return null;

  const [, year, month, day, hour, minute, second] = parsedDate;
  const timestamp = new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second)
  ).getTime();

  return Number.isNaN(timestamp) ? null : timestamp;
};

export default getDashboardDateTime;
